module.exports = __webpack_public_path__ + "img/default.e53afea7.svg";